import { useEffect, useState } from "react";
import CustomButton from "./CustomButton";
import Aos from "aos";
import { FaArrowsRotate } from "react-icons/fa6";

const RotatingProjectCard = ({ item, index, activeIndex, setActiveIndex }) => {
	const isFlipped = activeIndex === index;
	const [animate, setAnimate] = useState(true);

	useEffect(() => {
		if (isFlipped) setAnimate(false);
	}, [isFlipped]);

	useEffect(() => {
		Aos.init({ duration: 500 });
	}, []);

	return (
		<div
			key={index}
			className={`rotating-card ${isFlipped ? "flipped" : ""}`}
			{...(animate && {
				"data-aos": "zoom-in-up",
				"data-aos-offset": "180",
			})}
			onClick={() => setActiveIndex(isFlipped ? null : index)}
		>
			<div className="rotating-card-inner">

				{/* Front Side */}
				<div className="rotating-card-front">
					<img src={item.img} alt={item.headline} className="project-image" />
				</div>

				{/* Swap Button (Does not trigger flip) */}
				<button className="swap-btn"><FaArrowsRotate /></button>

				{/* Back Side */}
				<div className="rotating-card-back">
					<h3>{item.headline}</h3>
					<p dangerouslySetInnerHTML={{ __html: item.summary }}></p>
					<div className="rotating-card-links">
						{item.codelink && <CustomButton text="Code" theme="#00fffc" onHandle={() => window.open(item.codelink)} />}
						{item.livedemo && <CustomButton text="Visit" theme="#00fffc" onHandle={() => window.open(item.livedemo)} />}
						{item.videodemo && <CustomButton text="Video Demo" theme="#00fffc" onHandle={() => window.open(item.videodemo)} />}
						{item.filelink && <CustomButton text="Design" theme="#00fffc" onHandle={() => window.open(item.filelink)} />}
					</div>
				</div>
			</div>
		</div>
	);
};

export default RotatingProjectCard;
